import { find } from 'lodash';

const countriesConfig = require('../configs/countries.config.json');

export default (item) => {
    let result = {};
    let geometry = item.geometry;
    let addressСomponents = item.address_components;

    const regexpUnnamedRoad = new RegExp('Unnamed Road, ','gi');
    const formattedAddress = item.formatted_address.replace(regexpUnnamedRoad, '');
    result.formatted_address = formattedAddress;

    if (geometry && geometry.location) {
        result.coords = geometry.location;
    }

    if (addressСomponents) {
        addressСomponents.forEach(function(item) {
            let types = item.types;

            types.forEach(function(itemType) {
                switch (itemType) {
                    case 'postal_code':
                        result.postal_code = item.long_name;
                        break;
                    case 'country':
                        result.country_name = item.long_name;
                        result.country_iso = item.short_name;
                        break;
                    case 'administrative_area_level_1':
                        result.region = item.long_name;
                        break;
                    case 'administrative_area_level_2':
                        result.area = item.short_name;
                        break;
                    case 'locality':
                        result.city = item.long_name;
                        break;
                    case 'route':
                        if (item.short_name != 'Unnamed Road') {
                            result.street = item.short_name;
                        }
                        break;
                    case 'street_number':
                        result.street_number = item.short_name;
                        break;
                    case 'establishment':
                        result.establishment = item.long_name;
                        break;
                    case 'sublocality':
                        result.sublocality = item.long_name;
                        break;
                }
            });
        });

        if (!result.region) {
            result.region = result.city;
        }

        if (!result.city) {
            result.city = result.area ? result.area : null;
        }

        //Мосцощ Област
        if (result.region && result.region === 'Мосцощ Област') {
            result.region = 'Московская область';
        }

        //для станций метро
        if (!result.street && result.establishment) {
            result.street = result.establishment;
        }

        //для ( Профсоюзная ул., д. 109, к.2 Москва (юзао) 117647, Москва, Россия, 117647 )
        if (!result.street && result.city && result.sublocality) {
            result.street = result.sublocality;
        }

        result.country = 1;

        if (result.country_iso) {
            let countryField = find(countriesConfig, { iso: result.country_iso });

            if (countryField)
                result.country = countryField.id;
            else {
                result.country = null;
            }
        }
    }

    return result;
};



// WEBPACK FOOTER //
// ./tools/transform-google-geocoded-data.js